import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import * as moment from "moment";
import { ModalAddAvenantComponent } from "../../avanant/modal-add-avenant/modal-add-avenant.component";
import { ModalViewBeneficiaireDetailComponent } from "src/app/shared/components/modal-view-beneficiaire-detail/modal-view-beneficiaire-detail.component";
import { ModalViewPoliceDetailsComponent } from "src/app/shared/components/modal-view-police-details/modal-view-police-details.component";
import { ModalViewCollegeDetailComponent } from "src/app/shared/components/modal-view-college-detail/modal-view-college-detail.component";
import { ModalViewProduitDetailComponent } from "src/app/shared/components/modal-view-produit-detail/modal-view-produit-detail.component";
import { ModalViewProduitBaremeComponent } from "src/app/shared/components/modal-view-produit-bareme/modal-view-produit-bareme.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";

@Component({
  selector: "app-modal-add-beneficiaire",
  templateUrl: "./modal-add-beneficiaire.component.html",
  styleUrls: ["./modal-add-beneficiaire.component.scss"],
})
export class ModalAddBeneficiaireComponent implements OnInit {
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true;
  isAutoFill = false;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "beneficiaire";
  title: string = "bénéficiaire";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];
  itemsRemboursement = [
    { code: "ASSURE", libelle: "ASSURE PRINCIPAL" },
    { code: "CONJOINT", libelle: "CONJOINT" },
    { code: "SOUSCRIPTEUR", libelle: "SOUSCRIPTEUR" },
    { code: "ENFANT", libelle: "ENFANT" },
    { code: "ASCENDANT", libelle: "ASCENDANT" },
  ];
  avenant_ajustement_prime_id: any;
  gender = "F";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeRemboursement: any;
  itemsCourtier: any[];
  itemsCommercial: any;
  itemsSouscripteur: any;
  itemsCategoriePolice: any[];
  currentData: any;
  itemsModeTarification: any;
  itemsReseauDeSoin: any;
  itemsGarant: any;
  itemsAgence: any[];
  itemsStatutPolice: any;
  itemsStatutCollege: any[];
  itemsPolice: any[];
  itemsBareme: any;
  itemsStatut: any[];
  itemsGroupeSanguin: any[];
  itemsNaturePiece: any[];
  isAssurePrincipal: any;
  itemsCollege: any[];
  itemsAvenant: any;
  itemsAssurePrincipaux: any;
  itemAssure: any = {};
  current_college_id: any;
  current_police_id: any;
  current_avenant: void;
  current_avenant_id: any;
  current_matricule_assure: any;
  systemGlobal: any = [];
  mode_gestion_avenant: any;
  is_tpg: boolean;
  itemsTarif: any;
  itemsAffection: any;
  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;

    setTimeout(() => {
      // debugger
      console.log("here");
      this.itemToSave.date_entree = new Date();
      if (this.currentData) {
        this.itemToSave = Object.assign({}, this.currentData);
        // this.current_police_id = this.currentData.police_id;
        // this.current_college_id = this.currentData.college_id;
        // this.current_avenant_id = this.currentData.avenant_id;
        // this.current_matricule_assure = this.currentData.matricule_assure;
        // // this.current_police_id = this.currentData.police_id
        this.getItemsPolice(this.itemToSave.garant_id)
        console.log("this.currentData: ", this.currentData);
        this.imageDisplay = this.itemToSave.image_url;
        this.current_avenant = this.itemToSave.avenant_libelle;
        this.itemToSave.date_entree = new Date(this.itemToSave.date_entree);
        this.itemToSave.validite_piece = new Date(
          this.itemToSave.validite_piece
        );
        // this.onSelectGarant();
        // this.itemToSave.date_effet = moment(this.itemToSave.date_effet).toDate()
        this.itemToSave.date_naissance = moment(
          this.itemToSave.date_naissance
        ).toDate();
        this.itemToSave.date_naissance = moment(
          this.itemToSave.date_naissance
        ).toDate();
        this.getAge();
        // if(this.itemToSave.isAddBeneficiaire){
        //   this.itemToSave.matricule_assure = this.itemToSave.matricule
        //   this.itemToSave.id = null
        //   this.itemToSave.prenom = null
        //   this.itemToSave.civilite_id = null
        //   this.itemToSave.genre_id = null
        //   this.itemToSave.date_naissance = null
        //   this.itemToSave.groupe_sanguin_id = null
        //   this.itemToSave.taille = null
        //   this.itemToSave.matricule = null
        //   this.itemToSave.nature_piece_id = null
        //   this.itemToSave.numero_piece = null
        //   this.itemToSave.validite = null
        //   this.itemToSave.telephone = null
        //   this.itemToSave.telephone2 = null
        //   this.itemToSave.email = null
        //   this.itemToSave.email2 = null
        // }
        this.getItemsCollege(this.itemToSave.police_id);
        this.getItemsTypeRemboursement()

        console.log('session mode in add benef single: ',this.currentData.sessionMode)

      }
    }, 300);
  }
  confirmSaveItem(item) {
    console.info("item: ", item);

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);
    console.info("itemToSave.matricule_assure: ", this.itemToSave.matricule_assure);

    if (!item.id && !item.code) item.code = this.generateUniqueString();

    // item.specialiteId = this.selectedSpecialite.id

    
    if (!item || !item.garant_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner garant !",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.police_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner police !",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.college_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner collège!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.nom) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner nom!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.prenom) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner prenom!",
        "bottom",
        "center"
      );
      return;
    }

    // if (!item || !item.civilite_id) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner civilité!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    if (!item || !item.date_naissance) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner date de naissance!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.genre_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner genre!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.statut_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner statut!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item.avenant_id) {
      // this.utilities.openSwalError('Veuillez renseigner avenant')
      // return
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner avenant!",
        "bottom",
        "center"
      );
      return;
    }
    // if (!item.type_remboursement_id) {
    //   // this.utilities.openSwalError('Veuillez renseigner avenant')
    //   // return
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner type remboursement!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (
    //   this.mode_gestion_avenant === "MANUEL" &&
    //   item.id &&
    //   !this.avenant_ajustement_prime_id
    // ) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner avenant ajustement de prime!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    //condition le statut different de assuré principal, obliger le choix d'un assuré principal
    if(this.itemsStatut && this.itemsStatut.length){
let statut_codification = this.itemsStatut.filter(
      (is) => is.id == this.itemToSave.statut_id
    )[0].codification;
    if (statut_codification != "A") {
      if (!item.matricule_assure) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner l'assuré principal svp !",
          "bottom",
          "center"
        );
        return;
      }
    } else {
      // item.matricule_assure = "";
    }
    }
    

    let objToSave = Object.assign({}, item);
    console.info("objToSave: ", objToSave);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.saveItem(objToSave);
      }
    });
  }

  onSelectTypeRemboursement(){
    let selected_type_remboursement = this.itemsTypeRemboursement.find(itr=>itr.id == this.itemToSave.type_remboursement_id)
    this.is_tpg = selected_type_remboursement && selected_type_remboursement.codification == 'TPG'
    if(!this.itemToSave.taux_tpg){
      this.itemToSave.taux_tpg = 100
    }
    if(!this.itemToSave.plafond_tpg){
      this.itemToSave.plafond_tpg = 0
    }
    if(!this.itemToSave.majoration_tpg){
      this.itemToSave.majoration_tpg = 0
    }
  }
  saveItem(item) {
    // console.info("item to save", item);
    console.info("item: ", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    itemAEnregistrer.filiale_id = this.filiale_id || this.user.filiale_id;
    // itemAEnregistrer.matricule_assure = this.current_matricule_assure;
    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }

    // itemAEnregistrer.avenant_id = this.current_avenant_id;

    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      avenant_id: this.itemToSave.avenant_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint +
          "" +
          (itemAEnregistrer.id ? "/update" : "/incorporationCreate"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.bsModalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  addDocument(event) {
    console.log("addDocument: ", event);
    // this.datasFile = event;
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }

  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );

            if(this.itemToSave.id){
              this.onSelectTypeRemboursement()
            }
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => {
          this.itemsTypeRemboursement = [];
        }
      );
  }
  getItemsBeneficiaire() {
    // if(itemToSave.garant_id && itemToSave.police_id)
    // this.itemToSave.college_id = "";
    // this.itemToSave.police_id = "";
    // this.itemToSave.garant_id = "";
    this.isAutoFill = false;

    if (
      !this.itemToSave.matricule_assure ||
      this.itemToSave.matricule_assure.toString().length < 8
    ) {
      return;
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        // garant_id: this.itemToSave.garant_id,
        matricule: this.itemToSave.matricule_assure,
      },
    };

    this.busyGet = this.restClient
      .post("beneficiaire/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && res["items"].length) {
            this.itemAssure = res["items"][0];
            console.log("itemAssure: ",this.itemAssure)
            this.isAutoFill = true
            this.getItemsGarant();
            // this.itemToSave.college_id = this.itemAssure.college_id;
            // this.itemToSave.police_id = this.itemAssure.police_id;
            this.itemToSave.garant_id = this.itemAssure.garant_id;
            if(!this.itemToSave.nom)
              this.itemToSave.nom = this.itemAssure.nom;
            // 
            
            // this.isAutoFill = true;
          } else {
            this.itemAssure = {};
          }
        },
        (err) => {
          this.itemAssure = {};
        }
      );
  }
  getItemsCourtier() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("courtier/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCourtier = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsCourtier = [];
          }
        },
        (err) => {
          this.itemsCourtier = [];
        }
      );
  }

  getItemsVilite() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("civilite/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCivilite = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsCivilite = [];
          }
        },
        (err) => {
          this.itemsCivilite = [];
        }
      );
  }
  
  getItemsGenre() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("genre/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGenre = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsGenre = [];
          }
        },
        (err) => {
          this.itemsGenre = [];
        }
      );
  }
  getItemsNaturePiece() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("naturePiece/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsNaturePiece = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsNaturePiece = [];
          }
        },
        (err) => {
          this.itemsNaturePiece = [];
        }
      );
  }

  getItemsStatut() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatut = _.orderBy(res["items"], ["libelle"], ["asc"]);
            this.itemsStatut.sort((a, b) => this.customSort(a, b));

            this.getItemsAssure();
          } else {
            this.itemsStatut = [];
          }
        },
        (err) => {
          this.itemsStatut = [];
        }
      );
  }

  getItemsGroupeSanguin() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("groupeSanguin/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGroupeSanguin = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsGroupeSanguin = [];
          }
        },
        (err) => {
          this.itemsGroupeSanguin = [];
        }
      );
  }
  getItemsSouscripteur() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsSouscripteur = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsSouscripteur = [];
          }
        },
        (err) => {
          this.itemsSouscripteur = [];
        }
      );
  }
  getItemsCategoriePolice() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("categoriePolice/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCategoriePolice = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCategoriePolice = [];
          }
        },
        (err) => {
          this.itemsCategoriePolice = [];
        }
      );
  }

  getItemsReseauDeSoin() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("reseauDeSoin/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsReseauDeSoin = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsReseauDeSoin = [];
          }
        },
        (err) => {
          this.itemsReseauDeSoin = [];
        }
      );
  }
  getItemsGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarant = _.orderBy(res["items"], ["libelle"], ["asc"]);
            if(this.itemAssure && this.itemAssure.garant_id)
              this.getItemsPolice(this.itemAssure.garant_id);
            if(this.itemToSave.id){
              this.getItemsPolice(this.itemToSave.garant_id);
            }
            
          } else {
            this.itemsGarant = [];
          }
        },
        (err) => {
          this.itemsGarant = [];
        }
      );
  }

  getItemsAgence() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("agence/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsAgence = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsAgence = [];
          }
        },
        (err) => {
          this.itemsAgence = [];
        }
      );
  }
  getItemsAvenant(police_id?) {
    if (!this.itemToSave.police_id && !police_id) {
      return;
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      list_code_type_avenant: ["AVN-INC-BENEF", "AVN-AFF-NLLE"],
      data: {
        police_id: police_id ?? this.itemToSave.police_id,
      },
    };

    this.busyGet = this.restClient.post("avenant/getActive", request).subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsAvenant = _.orderBy(res["items"], ["libelle"], ["asc"]);
        } else {
          this.itemsAvenant = [];
        }
      },
      (err) => {
        this.itemsAvenant = [];
      }
    );
  }

  getItemsTarif() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("tarif/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsTarif = [];
          }
        },
        (err) => {
          this.itemsTarif = [];
        }
      );
  }
  getItemsAffection() {
   
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        
      },
    };

    this.busyGet = this.restClient.post("affection/getByCriteria", request).subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsAffection = _.orderBy(res["items"], ["libelle"], ["asc"]);
        } else {
          this.itemsAffection = [];
        }
      },
      (err) => {
        this.itemsAffection = [];
      }
    );
  }
  
  getItemsAssure() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        //Later ecrire un service spécial pour get les assuré principaux pour rendre dynamique
        statut_id: this.getStatutAssureId(),
      },
    };

    this.busyGet = this.restClient
      .post("beneficiaire/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsAssurePrincipaux = res["items"];
          } else {
            this.itemsAssurePrincipaux = [];
          }
        },
        (err) => {
          this.itemsAgence = [];
        }
      );
  }

  getStatutAssureId() {
    if (this.itemsStatut && this.itemsStatut.length) {
      let assurePrincipaux = this.itemsStatut.filter(
        (is) => is.codification == "A"
      );
      return assurePrincipaux[0].id;
    }
    return null;
  }
  getItemsStatutCollege() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statutCollege/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatutCollege = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsStatutCollege = [];
          }
        },
        (err) => {
          this.itemsStatutCollege = [];
        }
      );
  }

  getItemsPolice(garant_id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        garant_id: garant_id,
      },
    };

    this.busyGet = this.restClient
      .post("police/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPolice = _.orderBy(res["items"], ["libelle"], ["asc"]);
            if(this.itemAssure && this.itemAssure.police_id){
              this.itemToSave.police_id = this.itemAssure.police_id;
              this.getItemsCollege(this.itemAssure.police_id);
              this.getItemsAvenant(this.itemAssure.police_id);

            }
 
            // this.getItemsAvenant()

          } else {
            this.itemsPolice = [];
          }
        },
        (err) => {
          this.itemsPolice = [];
        }
      );
  }
  getItemsCollege(police_id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        police_id: this.current_police_id || police_id,
      },
    };

    this.busyGet = this.restClient
      .post("college/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCollege = _.orderBy(res["items"], ["libelle"], ["asc"]);
            if(this.itemAssure && this.itemAssure.college_id)
              this.itemToSave.college_id = this.itemAssure.college_id;
          } else {
            this.itemsCollege = [];
          }
        },
        (err) => {
          this.itemsCollege = [];
        }
      );
  }
  getItemsBareme(id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        garant_id: id,
      },
    };

    this.busyGet = this.restClient
      .post("bareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsBareme = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsBareme = [];
          }
        },
        (err) => {
          this.itemsBareme = [];
        }
      );
  }

  // onSelectDate(event) {
  //   if (event) {
  //     (this.dateNais = moment(event).format("DD/MM/YYYY")),
  //       console.info("dateNais", this.dateNais);
  //   }
  // }

  isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  load_filiale_data() {
    // this.getItems();
    this.getItemsTypeRemboursement();
  }

  onSelectGarant() {
    // this.itemToSave.police_id =''w
    this.itemToSave.police_id = "";
    this.itemToSave.college_id = "";
    this.itemToSave.avenant_id = "";
    this.itemsPolice = [];
    this.itemsCollege = [];
    this.itemsAvenant = [];
    this.getItemsPolice(this.itemToSave.garant_id);
  }
  onSelectAffection() {

  }

  onSelectPolice() {
    // this.itemToSave.college_id =''
    this.itemToSave.college_id = "";
    this.itemToSave.avenant_id = "";
    this.itemsCollege = [];
    this.itemsAvenant = [];
    this.getItemsCollege(this.itemToSave.police_id);
    this.getItemsAvenant();
  }
  onSelectCollege() {}

  // on_change_garant(){
  //   if(this.itemsGarant && this.itemsGarant.length){
  //     let current_garant = {...this.itemsGarant.filter(ig=>ig.id == this.itemToSave.garant_id)[0]}
  //     console.log('current_garant: ',current_garant)
  //     if(!this.itemToSave.id){
  //       this.itemToSave.taux_commission_sinistre = current_garant.taux_commission_sinistre
  //       this.itemToSave.forfait_commission_sinistre = current_garant.forfait_commission_sinistre
  //       this.itemToSave.taux_commission_prime = current_garant.taux_commission_prime
  //       this.itemToSave.forfait_commission_prime = current_garant.forfait_commission_prime
  //       this.itemToSave.type_remboursement_id = current_garant.type_remboursement_id
  //       this.itemToSave.seuil_alerte_conso = current_garant.seuil_alerte_conso
  //       this.itemToSave.seuil_suspension_tiers_payant = current_garant.seuil_suspension_tiers_payant
  //       this.itemToSave.assure_remboursement = current_garant.assure_remboursement
  //       this.itemToSave.mode_tarification_id = current_garant.mode_tarification_id
  //       this.itemToSave.mode_reconduction_id = current_garant.mode_reconduction_id
  //       this.itemToSave.mode_fractionnement_id = current_garant.mode_fractionnement_id
  //       this.itemToSave.reseau_de_soin_id = current_garant.reseau_de_soin_id
  //     }
  //   }

  // }

  openModalPrestataireReseau() {
    if (!this.itemToSave.reseau_de_soin_id) return;
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 5458545,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let reseau_id = this.itemToSave.reseau_de_soin_id;
    let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(
      (ird) => ird.id == reseau_id
    )[0].libelle;
    let data = {
      reseau_de_soin_id: reseau_id,
      reseau_de_soin_libelle: reseau_de_soin_libelle,
    };
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split(".")[0];
      const Tabextension = file.name.split(".");
      const extension = Tabextension[Tabextension.length - 1];

      console.info("fileName", fileName);
      console.info("extension", extension);
      this.imageName = fileName + "." + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(",")[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: "custom type",
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  onSelectStatut() {
    let statutCodification = this.itemsStatut.filter(
      (its) => its.id == this.itemToSave.statut_id
    )[0].codification;
    if (statutCodification == "A") {
      this.isAssurePrincipal = true;
      this.itemToSave.matricule_assure = this.itemToSave.matricule;
    } else {
      this.isAssurePrincipal = false;
    }
  }

  getAge() {
    if (this.itemToSave.date_naissance) {
      let age = moment().diff(this.itemToSave.date_naissance, "years");
      return age;
    }
    return 0;
  }

  openAddAvenant(data?) {
    let modal: any;
    modal = ModalAddAvenantComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 58,
      class: "modal-width-50",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0;
      this.getItemsAvenant();
    });
  }
  onPenDetailModal(item, type) {
    let data: any = "";

    let modal: any;
    if (type == "beneficiaire") {
      modal = ModalViewBeneficiaireDetailComponent;
      data = { id: this.itemToSave.beneficiaire_id };
    }
    if (type == "produit") {
      modal = ModalViewProduitDetailComponent;
      data = { id: this.itemToSave.produit_id };
    }
    if (type == "produitBareme") {
      modal = ModalViewProduitBaremeComponent;
      data = { id: this.itemToSave.produit_bareme_id };
    }
    if (type == "garant") {
      modal = ModalViewGarantDetailsComponent;
      data = { id: this.itemToSave.garant_id };
    }
    if (type == "college") {
      modal = ModalViewCollegeDetailComponent;
      data = { id: this.itemToSave.college_id };
    }

    if (type == "police") {
      modal = ModalViewPoliceDetailsComponent;
      data = { id: this.itemToSave.police_id };
    }

    this.modalRef = this.modalService.show(modal, {
      id: 545805401005,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

  customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }



  ngOnInit() {
    this.systemGlobal = JSON.parse(localStorage.getItem("globalSystem"));
    // console.log('systemGlobal: ',JSON.stringify(this.systemGlobal))
    if(this.systemGlobal && this.systemGlobal.length){
      this.mode_gestion_avenant = this.systemGlobal.find(
        (sg: any) => sg.codification == "mode_gest_avenant"
      ).valeur;
    }
    
    console.log("mode_gestion_avenant: ", this.mode_gestion_avenant);
    this.getItemsFiliale();
    this.getItemsTypeRemboursement();
    this.getItemsCourtier();
    this.getItemsStatut();
    this.getItemsSouscripteur();
    this.getItemsCategoriePolice();
    this.getItemsGroupeSanguin();
    this.getItemsReseauDeSoin();
    this.getItemsAgence();
    this.getItemsStatutCollege();
    this.getItemsGarant();
    this.getItemsVilite();
    this.getItemsGenre();
    this.getItemsNaturePiece();
    this.getItemsAvenant();
    this.getItemsTarif()
    // this.getItemsAffection()
  }
}
